import React, { useMemo } from 'react'
import diffInPercent from '../../utils/diffInPercent'
import Measurement, { humanizeMeasurement } from './Measurement'
import cn from 'classnames'
import useTranslate, { t } from '../../hooks/useTranslate'
import { noop } from '@iqueue/ui-kit'

export default function ProductionDiffLine({
  title,
  center,
  current = 0,
  currentPostfix,
  past = 0,
  percentage = true,
  unit,
}) {
  const { locale } = useTranslate()

  const diff = useMemo(() => {
    noop(locale)

    const value = current - past
    const out = {
      cn: value >= 0 ? 'up' : 'down',
      text: (value >= 0 ? '▲' : '▼')
    }

    if (percentage) {
      out.text += diffInPercent(current, past) + '%'
    } else {
      const { value: v , dimension } = humanizeMeasurement(Math.abs(value), unit)
      out.text += v + ' ' + dimension
    }

    return out
  }, [current, past, percentage, t, unit, locale])

  return <div className={ cn('production-diff-line', { center }) }>
    { !!title && <span className={ 'title' }>
      {/* !CAUTION! Inner span required for ellipsis! */ }
      <span>{ title }&nbsp;</span>
    </span> }
    <Measurement unit={ unit } postfix={ currentPostfix }>{ current }</Measurement>
    <span className={ diff.cn }>{ diff.text }</span>
  </div>
}
